module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Chart-line#2-ced32de12c1818d439708c51d139ed8c.svg";